import { Create, Edit, EditProps, ShowButton } from "react-admin";
import { TopToolBar } from "../shared-components";
import { ShowAddressTitle } from "./address-show";
import { BackToProfile } from "./address-top-toolbar";
import { CustomEditForm } from "./custom-edit-form";

const EditActions = (data: any) => {
  return (
    <TopToolBar left={<BackToProfile userID={data?.data?.user_id}/>} right={<ShowButton basePath={data.basePath} record={data.data} />}/>
  )};

const CreateActions = (data: any) => {
  return (
    <TopToolBar left={<BackToProfile userID={data?.location?.state?.id}/>} right={null}/>
  )};

export const EditAddress: React.FC<EditProps> = (props) => {
  const redirect = (basePath: string, id: string, data: any) => `/profiles/${data?.user_id}/show/addresses`;
  return (
    <Edit title={<ShowAddressTitle/>} actions={<EditActions/>} {...props}>
      <CustomEditForm redirect={redirect} warnWhenUnsavedChanges/>
    </Edit>
  )};

export const CreateAddress: React.FC<any> = (props) =>{
  const redirect = () => {
    return `/profiles/${props.location?.state?.id}/show/addresses`
  };
  return (
    <Create {...props} actions={<CreateActions {...props}/>}>
      <CustomEditForm redirect={redirect} warnWhenUnsavedChanges create {...props}/>
    </Create>
  )};
